import React from "react";
import { ETA_PURPLE } from "./constants";

// Section/card heading used by the vehicle card and the two trips tables:
// 20px Ubuntu Bold in Eta-Purple (per the Figma design).
const CardTitle = ({ children }) => (
  <h3 className="font-bold" style={{ fontSize: 20, color: ETA_PURPLE }}>
    {children}
  </h3>
);

export default CardTitle;
